import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {Stock} from "../../../../shared/view-model/stock";
import {Observable} from "rxjs/Observable";
import {TempWithdrawnStock} from "../../../../store-management/redux/scans.types";
import {IModel} from "../../../../shared/view-model/imodel.interface";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {TouchScanWizardService} from "../touch-scan-wizard/touch-scan-wizard.service";
import {GenericModalComponent} from "../../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {MedicineWithdrawalAuthFormComponent} from "../../../../store-management/withdrawal/medicine-withdrawal-auth-form/medicine-withdrawal-auth-form.component";
import {BarcodeScannerComponent} from "../../../../core/visbos-core/ui/components/barcode-scanner/barcode-scanner.component";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {StockService} from "../../../../store-management/services/stock.service";
import {map} from "rxjs/operators";
import {WithdrawalService} from '../../../../store-management/services/withdrawal.service';
import {WarehousingService} from '../../../../store-management/services/warehousing-service/warehousing.service';
import {AbstractVisbosControl} from '../../../../core/visbos-core/ui/forms/abstract-visbos-control';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../../../../shared/redux-store';
import {MessageType} from '../../../../shared/redux-store/session';

@Component({
  selector: 'vb-scan-stocks',
  templateUrl: './scan-stocks.component.html',
  styleUrls: ['./scan-stocks.component.css']
})
export class ScanStocksComponent extends AbstractVisbosComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('addMedDataModal')
  addMedDataModal: GenericModalComponent;

  @ViewChild('medForm')
  medForm: MedicineWithdrawalAuthFormComponent;

  @ViewChild(BarcodeScannerComponent)
  barcodeComponent: BarcodeScannerComponent;

  withdrawnStocks$: Observable<TempWithdrawnStock[]>;

  allowedScanTypes = ['Stock', 'AdministrationUnit', 'Vehicle', 'Client'];

  searchResultColumns = [
    {name: 'Bezeichner', prop: 'label'},
    {name: 'Lager', prop: 'depot.label'},
    {name: 'Lagerplatz', prop: 'depot_yard.label'},
  ];

  searchFunction = (term) => this.stockService.searchStocks(term)
    .pipe(map(({stocks}) => {
      let st = [...stocks];
      return st.sort((st1: Stock, st2: Stock) => st1.label.localeCompare(st2.label));
    }));

  @Output()
  articleScanFinished: EventEmitter<void> = new EventEmitter();

  editing: { [cuid: string]: boolean } = {};

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private ngRedux: NgRedux<IAppState>,
              public scanWizardService: TouchScanWizardService, private stockService: StockService,
              private wdService: WithdrawalService, private warehousingService: WarehousingService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.withdrawnStocks$ = this.scanWizardService.currentWithdrawal$.pipe(
      map(wd => {
        let revWd = Array.from(wd.withdrawn_stocks);
        revWd.reverse();
        return revWd;
      })
    );
  }

  onScanned(scannedItem: IModel) {

    if (!scannedItem || !this.scanWizardService.currentWithdrawal$ || !this.scanWizardService.currentConsumer) {
      return;
    }

    if (scannedItem.__typename == 'Stock') {
      this.onStockScanned(scannedItem);
      return;
    }

    if (scannedItem.cuid == this.scanWizardService.currentConsumer.cuid) {
      this.onScanFinished();
      return;
    }

    this.barcodeComponent.error("Der Barcode ist keinem Bestandsartikel zugeordnet!");

  }

  onScanFinished() {
    this.articleScanFinished.emit();
  }

  onStockScanned(stock: Stock) {
    this.scanWizardService.addStock(stock);

    if (stock.registration_required) {
      this.provideMedicineWithdrawalData();
    }
  }

  stockManuallyAdded(stock: Stock) {
    this.onStockScanned(stock);
  }

  removeStock(stock: Stock) {
    this.scanWizardService.removeStock(stock);
  }

  updateAmount(stock: Stock, amount: number) {
    this.scanWizardService.updateAmount(stock, amount);
  }

  updateActStock(stock: Stock, newActStock: number) {
    let oldActStock = stock.act_stock;
    let diff = newActStock - oldActStock;

    if (newActStock == newActStock) {
      console.info("No change in the actual stock");
    }
    if (newActStock < oldActStock) {
      this.onStockDecrease(stock, diff * -1);
    }
    if (newActStock > oldActStock) {
      this.onStockIncrease(stock, diff);
    }
  }

  onStockDecrease(stock: Stock, amount: number) {
    const withdrawalData = {
      cuid: AbstractVisbosControl.cuid(),
      administration_unit_id: this.activeAdminUnitCuid,
      withdrawal_timestamp: new Date(),
      withdrawal_reason_type: 'Bestandskorrektur',
      withdrawal_reason_id: null,
      withdrawal_note: 'Bestandskorrektur durch TouchBenutzer',
      consumer_type: 'Standort',
      consumer_id: this.activeAdminUnitCuid,
      withdrawn_stocks: [
        {
          cuid: AbstractVisbosControl.cuid(),
          stock_id: stock.cuid,
          amount: amount
        }
      ],
    }
    const medAuthData = {
      authenticated_user_token: this.ngRedux.getState().session.token,
      authenticated_user_cuid: this.scanWizardService.currentWithdrawal.authenticated_user ? this.scanWizardService.currentWithdrawal.authenticated_user.cuid : this.ngRedux.getState().session.user.cuid,
      personal_number: this.scanWizardService.currentPersonalNumber,
      signature: this.scanWizardService.currentSignature
    };

    this.wdService.createWithdrawal(withdrawalData, medAuthData).toPromise()
      .then(res => {
        stock.act_stock = res.withdrawn_stocks[0].stock.act_stock;
        this.sessionActions.pushMessage("Der Bestand wurde erfolgreich korrigiert!", MessageType.SUCCESS, "Bestandskorrektur");
      }).catch(err => {
      this.sessionActions.pushMessage("Fehler beim Korrigieren des Bestands!", MessageType.ERROR, "Bestandskorrektur");
    });
  }

  onStockIncrease(stock: Stock, amount: number) {
    const warehousingData = {
      cuid: AbstractVisbosControl.cuid(),
      administration_unit_id: this.activeAdminUnitCuid,
      warehousing_timestamp: new Date(),
      warehousing_reason_type: 'Bestandskorrektur',
      warehousing_reason_id: null,
      warehousing_note: 'Bestandskorrektur durch TouchBenutzer',
      supplier_type: 'Standort',
      supplier_id: this.activeAdminUnitCuid,
      increased_stocks: [
        {
          cuid: AbstractVisbosControl.cuid(),
          stock_id: stock.cuid,
          amount: amount
        }
      ],
    }
    const medAuthData = {
      authenticated_user_token: this.ngRedux.getState().session.token,
      authenticated_user_cuid: this.scanWizardService.currentWithdrawal.authenticated_user ? this.scanWizardService.currentWithdrawal.authenticated_user.cuid : this.ngRedux.getState().session.user.cuid,
      personal_number: this.scanWizardService.currentPersonalNumber,
      signature: this.scanWizardService.currentSignature
    };

    this.warehousingService.createWarehousing(warehousingData, medAuthData).toPromise()
      .then(res => {
        stock.act_stock = res.createWarehousing.increased_stocks[0].stock.act_stock;
        this.sessionActions.pushMessage("Der Bestand wurde erfolgreich korrigiert!", MessageType.SUCCESS, "Bestandskorrektur");
      }).catch(err => {
      this.sessionActions.pushMessage("Fehler beim Korrigieren des Bestands!", MessageType.ERROR, "Bestandskorrektur");
    });
  }

  provideMedicineWithdrawalData() {

    //TODO: Use new med auth component and make this one equal to the warehousing wizard.

    let userRequired = !this.scanWizardService.currentUser && !this.scanWizardService.currentPersonalNumber;
    let reasonRequired = !this.scanWizardService.canExitDataPage();

    if (userRequired || reasonRequired) {
      // Run CD so the form is loaded in the modal
      this.addMedDataModal.show();
      this.cd.detectChanges();

      this.medForm.form.get('personal_number').setValue(this.scanWizardService.currentPersonalNumber);
      this.medForm.form.get('signature').setValue(this.scanWizardService.currentSignature);
      this.barcodeComponent.enabled = false;
    }
    this.cd.detectChanges();
  }

  canSaveMedicineWithdrawalData(): boolean {
    let checkUser = this.medForm && this.medForm.form && this.medForm.form.valid;
    let missionCheck = this.medForm && this.medForm.form && this.medForm.missionForm && ((this.medForm.form.get('withdrawal_reason_type').value == 'Einsatz' && this.medForm.missionForm.valid) || this.medForm.form.get('withdrawal_reason_type').value != 'Einsatz');

    return checkUser && missionCheck;
  }

  canCancelMedicineWithdrawalData(): boolean {
    return ((this.scanWizardService.currentUser || this.scanWizardService.currentPersonalNumber) && (this.scanWizardService.currentWithdrawalReason != null));
  }

  saveMedicineWithdrawalData(data) {

    this.scanWizardService.selectWithdrawalReason(this.scanWizardService.withdrawalReasonCtrl.get('withdrawal_reason_type').value);
    this.scanWizardService.saveWithdrawalReason();

    this.scanWizardService.selectUserByPersonalNumber(data.personal_number, data.signature);

    this.barcodeComponent.enabled = true;
    this.cd.detectChanges();
  }


}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-scan/scan-stocks/scan-stocks.component.ts